import React, { useState, useCallback, useContext, useMemo, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { SearchGlobalParams, SearchGlobalRes, SearchType } from "@/services/SearchService";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import Tabs, { TabData } from "@/components/Modals/SearchGlobalModal/Tabs";
import { ListItemData } from "@/components/ListItem";
import logger from "@/utils/logger";
import { getJoySpacePageLink } from "@jd/focus-desktop-comps/lib/es/utils";
import bus from "@/utils/bus";
import "./index.less";
import { connect } from "dva";
import dayjs, { Dayjs } from "dayjs";
import { AddressNavKey } from "@/types/common";
import { EbookState } from "@/models/ebook";
import { getDeptCrumbList } from "@/services/EBookService";
import config, { ConfigEnum } from "@/config/config";
import { ScheduleDetailFrom } from "@/components/Calendars/Schedule/Detail";
import { analysisLog } from "@/utils/logAnalytics";
import { crossAppSwitch, isJSON } from "@/utils/tools";
import { notifyer } from "@/components/ThirdApp";
import { appTrailApply, getAppStoreUrl } from "@/components/ThirdApp/utils";
import { folderTypeEnum } from "../Joyspace/config/permissions.config";
import { message } from "antd";
import events from "../Joyspace/context/events";
import { FocusSDK, isFocusEnv } from "@/utils";
import { getGroupInfo } from "@/api/egroup";
import { v4 } from "uuid";
import { reportSearchRecord } from "@/api/search";
import ChatState from "@/types/chat/State";
import ImService from "@/server/ImService";
import { Session, SessionType } from "@/types/chat";
import { getWorkLineInfoList, firstUpdateTreeList } from "../AddressBook/common";
import CHAT_NOTICE from "@/contant/chat";
import { convertEmployeeToString } from "@/utils/chat/message";

interface GlobalSearchType {
  keyWord: string;
  activeKey?: SearchType;
  isChange?: boolean;
}
interface continuousKeyWordType {
  key: string;
  type: string;
}
const log = logger.getLogger("SearchGlobalModal");
export default connect(
  function ({ chat, ebook }: { chat: ChatState; ebook: EbookState }) {
    return {
      workLineTreeDataInfo: ebook.workLineTreeDataInfo,
      customAppList: chat.customAppList,
      currentEmployee: chat.currentEmployee,
      allSessionList: chat.allSessionList
    };
  },
  function (dispatch: any) {
    return {
      changeScheduleInfoDraw: (payload: {
        visible: boolean;
        scheduleId: string;
        selectedScheduleTime: Dayjs;
        from: number;
        openTime: Dayjs;
      }) =>
        dispatch({
          type: "calendar/changeScheduleInfoDraw",
          payload
        }),
      updateAddressNavKey(data: { addressNavKey: AddressNavKey }) {
        dispatch({ type: "ebook/updateAddressNavKey", payload: data });
      },
      updateTreeDataInfo(data: any) {
        dispatch({ type: "ebook/updateTreeDataInfo", payload: data });
      },
      setSelectedEbookId(data: any) {
        dispatch({ type: "ebook/setSelectedEbookId", payload: data });
      },
      setSelectedWorkLineEbookId(data: any) {
        dispatch({ type: "ebook/setSelectedWorkLineEbookId", payload: data });
      },
      updateWorkLineTreeDataInfo(data: any) {
        dispatch({ type: "ebook/updateWorkLineTreeDataInfo", payload: data });
      },
      setDeptCrumbList(data: any) {
        dispatch({ type: "ebook/setDeptCrumbList", payload: data });
      }
    };
  }
)(
  (
    props: GlobalSearchType & {
      changeScheduleInfoDraw: (payload: {
        visible: boolean;
        scheduleId: string;
        selectedScheduleTime: Dayjs;
        from: number;
        openTime: Dayjs;
      }) => void;
      customAppList: Session[];
      updateAddressNavKey: Function;
      setSelectedEbookId: Function;
      setSelectedWorkLineEbookId: Function;
      updateTreeDataInfo: Function;
      setDeptCrumbList: Function;
      workLineTreeDataInfo: any[];
      updateWorkLineTreeDataInfo: Function;
      setSearchGlobalValue?: (value: string) => void;
      currentEmployee: any;
      allSessionList: Session[];
    }
  ) => {
    const {
      activeKey = SearchType.All,
      keyWord = "",
      isChange,
      changeScheduleInfoDraw,
      updateAddressNavKey,
      setSelectedEbookId,
      setSelectedWorkLineEbookId,
      updateTreeDataInfo,
      setDeptCrumbList,
      setSearchGlobalValue,
      customAppList,
      workLineTreeDataInfo,
      currentEmployee,
      updateWorkLineTreeDataInfo,
      allSessionList
    } = props;
    const { authInfo: authData, focusSDK, service, appRuntimeEnv } = useContext<
      GlobalContextConfig
    >(GlobalContext);
    const isExternal =
      currentEmployee.userType === "1" ||
      currentEmployee.userType === "4" ||
      currentEmployee.userType === "5";
    const history = useHistory();
    const imService = ImService.getInstance();
    const [_activeKey, setActiveKey] = useState<SearchType>(activeKey);
    const continuousKeyWord: any = useRef([]);
    useMemo(() => {
      setActiveKey(activeKey);
    }, [activeKey]);

    const getWorkLineInfo = useCallback(async () => {
      const result = await getWorkLineInfoList({
        nodeId: "" // 参见出参中的subNodeList, 首次传空
      });
      if (result) {
        if (result.parentNodeList.length) {
          updateWorkLineTreeDataInfo(firstUpdateTreeList(result?.parentNodeList.slice(0, 1)));
        } else {
          updateWorkLineTreeDataInfo(firstUpdateTreeList(result?.subNodeList));
        }
      }
    }, [updateWorkLineTreeDataInfo]);

    useEffect(() => {
      if (isExternal) {
        getWorkLineInfo();
      }
      return () => {};
    }, [getWorkLineInfo, isExternal]);

    // start 特殊处理
    // const onChangeKey = useCallback((path) => {
    //     if (path === '/third_apps') {
    //         setActiveKey(SearchType.App);
    //     }
    // }, []);
    // useEffect(() => {
    //     bus.on('onHideGlobalSearch', onChangeKey);
    //     return () => {
    //         bus.off('onHideGlobalSearch', onChangeKey);
    //     };
    // }, [onChangeKey]);
    // // end
    const tabData: any = [
      { key: SearchType.All },
      { key: SearchType.Contacts },
      { key: SearchType.Department },
      { key: SearchType.Group },
      { key: SearchType.MessageHistory },
      { key: SearchType.JoySpace },
      { key: SearchType.Task },
      { key: SearchType.Schedule },
      { key: SearchType.App }
      // 大搜暂且隐藏组织号tab
      // { key: SearchType.Sub }
    ].filter(
      (item: any) =>
        !(
          (item.key === SearchType.JoySpace && !crossAppSwitch("joyspace")) ||
          (item.key === SearchType.App && !crossAppSwitch("threeApp")) ||
          (item.key === SearchType.Task && !crossAppSwitch("joywork")) ||
          (item.key === SearchType.Schedule && !crossAppSwitch("calendar")) ||
          (item.key === SearchType.Task && !crossAppSwitch("joywork"))
        )
    );
    const tabDataFilterDept = tabData.filter((item: any) => item.key !== SearchType.Department);
    const tab: TabData[] =
      config[ConfigEnum.EXTERNAL_CONTACTS_SEARCH_DEPARTMENT] ||
      (isExternal && workLineTreeDataInfo.length)
        ? tabData
        : tabDataFilterDept;
    const clearContinuousKeyWord = () => {
      continuousKeyWord.current = [];
    };
    const findKeyByValue = (obj: any, value: string) => {
      return Object.keys(obj).find((key) => obj[key] === value);
    };
    const reportSearchRecordHandle = useCallback(
      (type: SearchType, dataParam: ListItemData & { pageSortNo: number; pageSize: number }) => {
        try {
          const searchType = findKeyByValue(SearchType, type);
          if (!continuousKeyWord.current?.length && keyWord) {
            continuousKeyWord.current = [{ key: keyWord, type: searchType }];
          }
          const searchHit =
            type === SearchType.MessageHistory
              ? JSON.stringify(dataParam)
              : JSON.stringify({
                  ...dataParam.origin,
                  pageSortNo: dataParam.pageSortNo,
                  pageSize: dataParam.pageSize
                });
          if (!continuousKeyWord.current?.length || !searchType || !searchHit) return;
          reportSearchRecord({
            keyword: JSON.stringify(continuousKeyWord.current),
            searchUuid: v4(),
            searchHit,
            searchType
          })
            .then(() => {
              clearContinuousKeyWord();
            })
            .catch((error) => {
              clearContinuousKeyWord();
              FocusSDK.printLog("search********--->>>", error.message?.toString());
            });
        } catch (error) {
          clearContinuousKeyWord();
          FocusSDK.printLog("report********--->>>", error.message?.toString());
        }
      },
      [keyWord]
    );
    const saveHistoryGlobalSearchKeyword = useCallback(() => {
      try {
        const globalSearchId =
          authData.userId +
          "-" +
          authData.ddAppId +
          "-" +
          authData.teamUserInfo?.teamId +
          "-search-keyword";
        const globalSearchKeyword = localStorage.getItem(globalSearchId);
        const value = keyWord.trim();
        if (globalSearchKeyword && isJSON(globalSearchKeyword)) {
          let globalSearchKeywordList = JSON.parse(globalSearchKeyword);
          if (Array.isArray(globalSearchKeywordList)) {
            globalSearchKeywordList = [value, ...globalSearchKeywordList]
              .filter((value: string, index: number, arr: Array<string>) => {
                return arr.indexOf(value) === index;
              })
              .splice(0, 20);
          } else {
            globalSearchKeywordList = [value];
          }
          localStorage.setItem(globalSearchId, JSON.stringify(globalSearchKeywordList));
        } else {
          localStorage.setItem(globalSearchId, JSON.stringify([value]));
        }
      } catch (error) {
        FocusSDK.printLog("ky --->>>", error.message?.toString());
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authData.ddAppId, authData.teamUserInfo?.teamId, authData.userId, keyWord]);

    const getSid = (data: any) => {
      let groupId = data.groupId;
      customAppList.forEach((item: any) => {
        if (data?.userId === item?.info?.userId) {
          addAiSession(data.userId);
          groupId = item.sessionId;
        }
      });
      return groupId;
    };
    const addAiSession = async (userId: string) => {
      const session = await imService.getSingleSession(
        {
          app: "dd.notice",
          userId: userId,
          teamId: "focus.bot"
        } as any,
        {
          ...currentEmployee,
          pin: currentEmployee.userId
        },
        SessionType.NOTICE,
        false,
        true
      );
      if (session) {
        bus.emit("chat:session-update", session);
      }
    };
    const onItemClick = useCallback(
      // eslint-disable-next-line complexity
      async (
        type: SearchType,
        dataParam: ListItemData & { pageSortNo: number; pageSize: number }
      ) => {
        // 保存历史所搜数据
        saveHistoryGlobalSearchKeyword();
        reportSearchRecordHandle(type, dataParam);
        try {
          const { origin: data } = dataParam;
          bus.emit("onHideGlobalSearch", false);
          switch (type) {
            case SearchType.Schedule:
              console.log("😄触发搜索日程item点击事件", data);
              changeScheduleInfoDraw({
                visible: true,
                scheduleId: data.scheduleId,
                selectedScheduleTime: dayjs(data.beginTime),
                from: ScheduleDetailFrom.Search,
                openTime: dayjs()
              });
              break;
            case SearchType.JoySpace:
              if (data?.pageType === "9") {
                const { spaceType, pageId: gid, spaceId: groupId } = data;
                switch (spaceType) {
                  case folderTypeEnum.MY:
                    history.push(`/joyspace/myspace?categoryId=${gid}`);
                    break;
                  case folderTypeEnum.SHARE:
                    history.push(`/joyspace/teamspace?categoryId=${gid}`);
                    break;
                  case folderTypeEnum.GROUP:
                    try {
                      const res = await getGroupInfo({
                        groupIds: [{ groupId: groupId }]
                      });
                      // eslint-disable-next-line max-depth
                      if (res.groups[0].status === 0) {
                        message.error("该群已解散！");
                      } else {
                        setTimeout(() => {
                          history.push(`/messages/g/${groupId}?top=true`);
                          events.emit("joyspace.groupSpace", {
                            visible: true,
                            gname: data?.spaceName,
                            gid: groupId,
                            categoryId: gid
                          });
                        }, 400);
                      }
                    } catch (error) {
                      message.error("当前版本暂不支持，请升级至最新版本");
                      FocusSDK.printLog("search*******group--->>>", error.message?.toString());
                    }
                    break;
                  default: {
                    message.error("当前版本暂不支持，请升级至最新版本");
                    return;
                  }
                }
              } else {
                analysisLog(
                  "xtbg_jzb_joysapce_inOtherModule_1676971574856",
                  _activeKey === SearchType.JoySpace ? "11" : "10",
                  data.pageType || data.page_type,
                  data.id || data.pageId
                );
                window.open(getJoySpacePageLink(appRuntimeEnv.joyspaceHost, data));
              }
              break;
            case SearchType.App:
              // 机器人
              if (data?.ext.isBot) {
                const { robotId, appId, teamId } = data?.ext || {};
                history.push(`/messages/s/${robotId}?app=${appId}&tid=${teamId}&top=true`);
                return;
              }
              // 有个BUG，当打开的页面和跳转页面一样是，不触发 useLocation
              history.push({
                pathname: "/third_apps"
                // state: { applicationInfo: data.ext },
              });
              if (!data.addApp && data.ext.deployStatus === "1") {
                // 市场应用
                let appStoreUrl = getAppStoreUrl(appRuntimeEnv, authData);
                appStoreUrl += `#/appInfo/${data.ext.applicationId}`;
                if (FocusSDK.getDeviceInfo().platform === "web") {
                  appStoreUrl && FocusSDK.openUrl(appStoreUrl);
                } else {
                  notifyer.emit("clientMessage", {
                    event: "openNewWindow",
                    payload: {
                      urls: [appStoreUrl]
                    }
                  });
                }
                return;
              }
              // 临时解决方案
              setTimeout(() => {
                appTrailApply(
                  data.ext.applicationId,
                  // eslint-disable-next-line max-nested-callbacks
                  () => {
                    bus.emit("openThirdApp", data.ext, data);
                  },
                  notifyer,
                  data.ext
                );
              }, 700);
              break;
            case SearchType.Contacts:
              log.debug("handleSearchType contacts ==>", type, data);
              const { userId, teamId, app } = data; // eslint-disable-line
              // TODO: 单聊密聊会话跳转 参数添加isSecret
              if (userId === CHAT_NOTICE.AI_CHAT_PIN && isFocusEnv()) {
                // 智能助理
                FocusSDK.launchAIChatSession(
                  `aiRobot:dd.notice:focus.bot:${convertEmployeeToString(currentEmployee)}:chat`,
                  () => {},
                  true
                );
              } else {
                history.push(`/messages/s/${userId}?app=${app}&tid=${teamId}&top=true`);
              }
              break;
            case SearchType.Group:
              logger.debug("handleSearchType group ==>", type, data);
              if (data.type === "notice") {
                const gid = getSid(data);
                history.push(`/messages/n/${gid}?top=true`);
              } else {
                history.push(`/messages/g/${data.groupId}?top=true`);
              }
              break;
            case SearchType.Task:
              break;
            case SearchType.Department:
              logger.debug("handleSearchType Department ==>", dataParam);
              // eslint-disable-next-line no-case-declarations
              const DeptList = await getDeptCrumbList(dataParam);
              console.log(DeptList, dataParam?.id, "DeptList");
              setDeptCrumbList(DeptList);
              if (dataParam.origin?.nodeType === "1") {
                setSelectedWorkLineEbookId({ nodeId: dataParam?.id });
              } else {
                setSelectedEbookId(dataParam?.id);
              }
              updateAddressNavKey({
                addressNavKey:
                  dataParam.origin?.nodeType === "1"
                    ? `${AddressNavKey.WORK_LINE}-${dataParam?.id}`
                    : AddressNavKey.ORG
              });
              history.push("/address_list");
              break;
            default: {
              return;
            }
          }
        } catch (e) {
          log.error("item click error", e);
          return;
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [
        changeScheduleInfoDraw,
        appRuntimeEnv.joyspaceHost,
        history,
        saveHistoryGlobalSearchKeyword,
        customAppList,
        currentEmployee
      ]
    );
    const onSearchGlobal = useCallback(
      (params: SearchGlobalParams): Promise<SearchGlobalRes> => {
        try {
          const keywordList = continuousKeyWord.current?.map(
            (item: continuousKeyWordType) => item.key
          );
          if (keywordList.join("").length <= 1800) {
            let searchType = findKeyByValue(SearchType, params.searchType);
            continuousKeyWord.current = [
              ...continuousKeyWord.current,
              { key: params.keyword, type: searchType }
            ];
          }
        } catch (error) {
          FocusSDK.printLog("search--->>>", error.message?.toString());
        }
        return service.searchService.searchGlobal(params);
      },
      [service.searchService]
    );
    useEffect(() => {
      bus
        .off("search:save-history-keyword", saveHistoryGlobalSearchKeyword)
        .on("search:save-history-keyword", saveHistoryGlobalSearchKeyword);
      bus
        .off("search:report-search-record", reportSearchRecordHandle)
        .on("search:report-search-record", reportSearchRecordHandle);
      bus
        .off("search:clear-continuous-keyword", clearContinuousKeyWord)
        .on("search:clear-continuous-keyword", clearContinuousKeyWord);
      return () => {
        bus.off("search:save-history-keyword", saveHistoryGlobalSearchKeyword);
        bus.off("search:report-search-record", reportSearchRecordHandle);
        bus.off("search:clear-continuous-keyword", clearContinuousKeyWord);
      };
    }, [keyWord, reportSearchRecordHandle, saveHistoryGlobalSearchKeyword]);
    return (
      <div className="global-search-content">
        <Tabs
          authData={authData}
          keyword={keyWord.trim()} // 应 沈判 需求，全局搜索的input可以输入空格
          onSearchGlobal={onSearchGlobal}
          config={tab}
          activeKey={_activeKey}
          onItemClick={onItemClick}
          onActiveKeyChange={(key) => {
            setActiveKey(key);
          }}
          isChange={isChange}
          setSearchGlobalValue={setSearchGlobalValue}
        />
        {/* {_activeKey === SearchType.JoySpace && <ConditionSearch searchType={_activeKey} />} */}
      </div>
    );
  }
);
